<script lang="ts">
  import CharityDashboard from '../../components/charity/dasboard/CharityDashboard.svelte';
</script>

<div class="charity-dashboard-page">
  <CharityDashboard />
</div>

<style>
  .charity-dashboard-page {
    min-height: 100vh;
    background-color: #f9fafb;
  }
</style> 